import { type InputHTMLAttributes, forwardRef } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, className = "", id, ...rest }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, "-");

    return (
      <div className="xpn-input-group">
        {label && (
          <label className="xpn-input-label" htmlFor={inputId}>
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={`xpn-input ${error ? "xpn-input--error" : ""} ${className}`}
          {...rest}
        />
        {error && <span className="xpn-input-error">{error}</span>}
        {hint && !error && <span className="xpn-input-hint">{hint}</span>}
      </div>
    );
  }
);

Input.displayName = "Input";
